import {API_DRIVER} from "../config/axios";

interface IRegisterSubscription {
    endpoint: string
    keys: {
        p256dh: string
        auth: string
    }
}

interface IUnregisterSubscription {
    endpoint: string
    user_id: string
}

const SubscriptionsService = {
    subscribeToPushNotifications: (body: IRegisterSubscription) => {
        return API_DRIVER.post('/api/subscriptions/register', body)
    },
    unsubscribeFromPushNotifications: (body: IUnregisterSubscription) => {
        return API_DRIVER.post('/api/subscriptions/unregister', body)
    }
}

export default SubscriptionsService
